import React from "react";
import { useSelector } from "react-redux";
import { faBan, faCheckCircle, faStopwatch, faSync } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { savedLocallySelector } from "@/lib/state/selectors/saved-locally-selector";

const LocalSaveStatus = () => {
  const savedLocally = useSelector(savedLocallySelector);

  if (savedLocally === "queued") {
    return (
      <span className="text-gray-500 mx-4">
        <FontAwesomeIcon icon={faStopwatch} /> Waiting...
      </span>
    );
  } else if (savedLocally === "pending") {
    return (
      <span className="text-gray-500 mx-4">
        <FontAwesomeIcon icon={faSync} /> Saving locally
      </span>
    );
  } else if (savedLocally === "unsupported") {
    return (
      <span className="text-red-500 mx-4">
        <FontAwesomeIcon icon={faBan} /> Cannot save
      </span>
    );
  } else {
    return (
      <span className="text-gray-500 mx-4">
        <FontAwesomeIcon icon={faCheckCircle} /> Saved locally
      </span>
    );
  }
};

export default LocalSaveStatus;
